// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "feature/v1/feature.proto" (package "feature.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Feature flag RPCs and protos
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message feature.v1.Feature
 */
export interface Feature {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: string string_value = 2;
         */
        stringValue: string;
    } | {
        oneofKind: "boolValue";
        /**
         * @generated from protobuf field: bool bool_value = 3;
         */
        boolValue: boolean;
    } | {
        oneofKind: "floatValue";
        /**
         * @generated from protobuf field: double float_value = 4;
         */
        floatValue: number;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message feature.v1.GetFeaturesRequest
 */
export interface GetFeaturesRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
}
/**
 * @generated from protobuf message feature.v1.GetFeaturesResponse
 */
export interface GetFeaturesResponse {
    /**
     * @generated from protobuf field: repeated feature.v1.Feature features = 1;
     */
    features: Feature[];
}
/**
 * @generated from protobuf message feature.v1.SetFeatureRequest
 */
export interface SetFeatureRequest {
    /**
     * @generated from protobuf field: string organization_id = 1;
     */
    organizationId: string;
    /**
     * @generated from protobuf field: feature.v1.Feature feature = 2;
     */
    feature?: Feature;
}
/**
 * @generated from protobuf message feature.v1.SetFeatureResponse
 */
export interface SetFeatureResponse {
    /**
     * previous value
     *
     * @generated from protobuf field: feature.v1.Feature prev = 1;
     */
    prev?: Feature;
}
/**
 * Empty - gets all feature defaults
 *
 * @generated from protobuf message feature.v1.GetFeatureDefaultsRequest
 */
export interface GetFeatureDefaultsRequest {
}
/**
 * @generated from protobuf message feature.v1.GetFeatureDefaultsResponse
 */
export interface GetFeatureDefaultsResponse {
    /**
     * @generated from protobuf field: repeated feature.v1.Feature features = 1;
     */
    features: Feature[];
}
/**
 * @generated from protobuf message feature.v1.SetFeatureDefaultRequest
 */
export interface SetFeatureDefaultRequest {
    /**
     * @generated from protobuf field: feature.v1.Feature feature = 1;
     */
    feature?: Feature;
}
/**
 * @generated from protobuf message feature.v1.SetFeatureDefaultResponse
 */
export interface SetFeatureDefaultResponse {
    /**
     * previous default value
     *
     * @generated from protobuf field: feature.v1.Feature prev = 1;
     */
    prev?: Feature;
}
// @generated message type with reflection information, may provide speed optimized methods
class Feature$Type extends MessageType<Feature> {
    constructor() {
        super("feature.v1.Feature", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "string_value", kind: "scalar", oneof: "value", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "bool_value", kind: "scalar", oneof: "value", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "float_value", kind: "scalar", oneof: "value", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.Feature
 */
export const Feature = new Feature$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFeaturesRequest$Type extends MessageType<GetFeaturesRequest> {
    constructor() {
        super("feature.v1.GetFeaturesRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.GetFeaturesRequest
 */
export const GetFeaturesRequest = new GetFeaturesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFeaturesResponse$Type extends MessageType<GetFeaturesResponse> {
    constructor() {
        super("feature.v1.GetFeaturesResponse", [
            { no: 1, name: "features", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.GetFeaturesResponse
 */
export const GetFeaturesResponse = new GetFeaturesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFeatureRequest$Type extends MessageType<SetFeatureRequest> {
    constructor() {
        super("feature.v1.SetFeatureRequest", [
            { no: 1, name: "organization_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "feature", kind: "message", T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.SetFeatureRequest
 */
export const SetFeatureRequest = new SetFeatureRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFeatureResponse$Type extends MessageType<SetFeatureResponse> {
    constructor() {
        super("feature.v1.SetFeatureResponse", [
            { no: 1, name: "prev", kind: "message", T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.SetFeatureResponse
 */
export const SetFeatureResponse = new SetFeatureResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFeatureDefaultsRequest$Type extends MessageType<GetFeatureDefaultsRequest> {
    constructor() {
        super("feature.v1.GetFeatureDefaultsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.GetFeatureDefaultsRequest
 */
export const GetFeatureDefaultsRequest = new GetFeatureDefaultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFeatureDefaultsResponse$Type extends MessageType<GetFeatureDefaultsResponse> {
    constructor() {
        super("feature.v1.GetFeatureDefaultsResponse", [
            { no: 1, name: "features", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.GetFeatureDefaultsResponse
 */
export const GetFeatureDefaultsResponse = new GetFeatureDefaultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFeatureDefaultRequest$Type extends MessageType<SetFeatureDefaultRequest> {
    constructor() {
        super("feature.v1.SetFeatureDefaultRequest", [
            { no: 1, name: "feature", kind: "message", T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.SetFeatureDefaultRequest
 */
export const SetFeatureDefaultRequest = new SetFeatureDefaultRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetFeatureDefaultResponse$Type extends MessageType<SetFeatureDefaultResponse> {
    constructor() {
        super("feature.v1.SetFeatureDefaultResponse", [
            { no: 1, name: "prev", kind: "message", T: () => Feature }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message feature.v1.SetFeatureDefaultResponse
 */
export const SetFeatureDefaultResponse = new SetFeatureDefaultResponse$Type();
/**
 * @generated ServiceType for protobuf service feature.v1.FeatureFlagService
 */
export const FeatureFlagService = new ServiceType("feature.v1.FeatureFlagService", [
    { name: "GetFeatures", options: {}, I: GetFeaturesRequest, O: GetFeaturesResponse },
    { name: "SetFeature", options: {}, I: SetFeatureRequest, O: SetFeatureResponse },
    { name: "GetFeatureDefaults", options: {}, I: GetFeatureDefaultsRequest, O: GetFeatureDefaultsResponse },
    { name: "SetFeatureDefault", options: {}, I: SetFeatureDefaultRequest, O: SetFeatureDefaultResponse }
]);
